import React, { useEffect } from 'react';
import './Home.css'; // Import shared styles, variables, and animations
import './AboutUs.css'; // Import page-specific styles

export default function AboutUs() {
  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = 'https://www.ceylonext.com/about';
    document.title = 'About Us | CeyloNext - Web Developing Company in Sri Lanka';
  }, []);

  return (
    <main className="main-content">
      {/* Reuse the background graphics from the Home page 
        for consistent atmosphere.
      */}
      <div className="graphics-placeholder">
        <div className="sphere"></div>
        <div className="liquid-blob"></div>
      </div>

      {/* Wrapper for all "About Us" content */}
      <div className="about-section">

        <div className="hero-text">
          <h1>ABOUT US</h1>

        </div>
        <p className="hero-subtext">
          We are a collective of thinkers, designers, and builders.
          Our passion is crafting digital experiences that not only
          look beautiful but also perform flawlessly.
        </p>
        {/* New content specific to the About page */}
        <div className="about-content">

          <div className="about-block">
            <h2>Our Mission</h2>
            <p>
              To blend creativity and technology to build solutions that
              empower brands and inspire people. We believe in a digital
              world that is accessible, intelligent, and human-centric.
            </p>
          </div>

          {/* === "Meet The Team" section removed and replaced with "Our Values" === */}
          <div className="about-block">
            <h2>Our Values</h2>
            <p>
              <strong>Innovation:</strong> We constantly push the boundaries of
              technology, embracing new ideas to deliver cutting-edge solutions
              that drive success.
            </p>
            <p>
              <strong>Collaboration:</strong> We believe the best results come
              from working together. We foster a collaborative environment,
              merging our expertise with our clients' vision.
            </p>
            <p>
              <strong>Integrity:</strong> We build relationships on a foundation
              of honesty and transparency. We are accountable for our work
              and committed to doing what's right.
            </p>
          </div>
          {/* === End of replaced section === */}

        </div>
      </div>
    </main>
  );
}